import Rating from '../../../../src/component/rating/Rating.component';
import RatingNPS from '../../../../src/component/rating/RatingNPS.component';
import { FormInputMultiline } from '../../../component/input/InputStyle';
import FormLabel from '../../../component/input/FormLabel.component';
import { useParams } from 'react-router-dom';
import ParamTypes from '../../../core/interfaces/ParamTypes';
import { ChangeEvent, useState, useEffect } from 'react';
import { CommentInterface } from '../../store/details/assessment/interface/AssesmentInterface';
import { RatingQuestionInterface } from '../../store/details/assessment/interface/RatingQuestionInterface';
import { getRatingComment, getRatingQuestion } from '../../store/details/Details.service';
import Details from '../operationalIndicator/Details.component';
import { getUser } from '../../../core/auth/auth';
import Progress from '../../../component/progress/Progress.component';
import ButtonLink from '../../../component/buttton/ButtonLink.component';

export default function Answer() {
  let { id, idAssesment } = useParams<ParamTypes>();
  const [values, setValues] = useState<any>();
  const [ratingComment, setRatingComment] = useState<CommentInterface[]>([]);
  const [ratingQuestion, setRatingQuestion] = useState<RatingQuestionInterface[]>([]);
  const [ratingQuestionNPS, setRatingQuestionNPS] = useState<RatingQuestionInterface[]>([]);
  const [load, setLoad] = useState(true);
  const [userComment, setUserComment] = useState<CommentInterface[]>([]);

  const getAvaliations = async () => {
    try {
      const getQuestion = await getRatingQuestion().then((data) => data);

      const question = getQuestion.data
        .filter(
          (data: RatingQuestionInterface) =>
            data.idAvaliacao?.id === idAssesment && !data.idPerguntaPesquisa.flNPS
        )
        .sort((x: RatingQuestionInterface, y: RatingQuestionInterface) => {
          return x.idPerguntaPesquisa.dsPesquisa.length - y.idPerguntaPesquisa.dsPesquisa.length;
        });

      const questionNPS = getQuestion.data.filter(
        (data: RatingQuestionInterface) =>
          data.idAvaliacao?.id === idAssesment && data.idPerguntaPesquisa.flNPS
      );

      setTimeout(async () => {
        const getComment = await getRatingComment().then((data) => data);

        const comment: CommentInterface[] = getComment.data.filter(
          (data: CommentInterface) => data.idAvaliacao?.id === idAssesment
        );

        if (comment.length > 1) {
          comment.sort(function (a, b) {
            if (a.createdAt > b.createdAt) {
              return 1;
            } else {
              return -1;
            }
          });
        }

        setUserComment(comment);

        setRatingComment(comment);
        setRatingQuestion(question);
        setRatingQuestionNPS(questionNPS);
        setLoad(false);
      }, 1000 * 1.5);
    } catch (err) {
      console.log('Error: ', err);
    }
  };

  useEffect(() => {
    getAvaliations();
  }, []);

  const onChange = (value?: number | null) => {
    console.log(value);
  };

  return (
    <>
      <Details />
      {load === true ? (
        <Progress open={load} />
      ) : (
        <>
          {ratingQuestion.map((question) => (
            <Rating
              title={question.idPerguntaPesquisa.dsPesquisa}
              onChange={onChange}
              IconContainerComponent={question.idPerguntaPesquisa.flNPS}
              assesment={parseInt(question.vlrPesquisa)}
            />
          ))}
          {ratingQuestionNPS.map((question) => (
            <RatingNPS title={question.idPerguntaPesquisa.dsPesquisa} data={question.vlrPesquisa} />
          ))}

          <FormLabel title='Comentário' sm={12}>
            <FormInputMultiline
              name='NumeroLoja'
              value={userComment[0].dsComentario}
              onChange={() => {}}
              disabled={true}
            />
          </FormLabel>

          {userComment.length > 1 && (
            <>
              <br />

              <FormLabel title='Comentário da Loja' sm={12}>
                <FormInputMultiline
                  name='NumeroLoja'
                  value={userComment[1].dsComentario}
                  onChange={() => {}}
                  disabled={true}
                />
              </FormLabel>
            </>
          )}

          <br />
          <ButtonLink
            link={'/avaliacao-loja/avaliacoes'}
            size='medium'
            title='Voltar'
            variant='outlined'
          />
        </>
      )}
    </>
  );
}
